import { useEffect, useState, useCallback } from 'react';

export function useWindowFocus(onFocus?: () => void) {
  const [isWindowFocused, setIsWindowFocused] = useState(true);

  const handleFocus = useCallback(() => {
    setIsWindowFocused(true);
    // Custom auth kontrolü - session temizleme yapma
    const customToken = localStorage.getItem('custom_auth_token');
    if (customToken) {
      return;
    }
    if (onFocus) {
      onFocus();
    }
  }, [onFocus]);

  useEffect(() => {
    const handleBlur = () => {
      setIsWindowFocused(false);
    };

    const handleVisibilityChange = () => {
      const isVisible = !document.hidden;
      setIsWindowFocused(isVisible);
      // Custom auth kontrolü - session temizleme yapma
      const customToken = localStorage.getItem('custom_auth_token');
      if (customToken) {
        return;
      }
      if (isVisible && onFocus) {
        onFocus();
      }
    };

    // Add event listeners
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Set initial state
    setIsWindowFocused(!document.hidden);

    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleFocus, onFocus]);

  return isWindowFocused;
}
